import moment from 'moment'

export const getBrowserTimeZone = (ignoreCache) => moment.tz.guess(ignoreCache)

const hasCookie = (name) => document.cookie.split(';').some(c => c.trim().startsWith(name + '='))

export const isImpersonating = () => hasCookie('aloware_shared_auth_token-imp') || hasCookie('aloware_shared_auth_token-admin-imp')

export const isAdminImpersonating = () => hasCookie('aloware_shared_auth_token-admin-imp')

export const getDateInBrowserTimeZone = (date) => {
  return moment(date).tz(getBrowserTimeZone())
}
